module.exports = __webpack_public_path__ + "static/media/image3.2c111a8f.png";